import { CurrencyCodes, LanguageCodes } from '@onevesthq/ov-enums';

const handleUrl = (
  urlString: string,
  currencies: string,
  language?: LanguageCodes,
): string => {
  try {
    // Flinks supports only English and French languages
    const paramsLanguage =
      language === LanguageCodes.FR ? LanguageCodes.FR : LanguageCodes.EN;
    const url = new URL(urlString);
    if (url.searchParams.has('accountSelectorCurrency')) {
      url.searchParams.set('accountSelectorCurrency', currencies);
    } else {
      url.searchParams.append('accountSelectorCurrency', currencies);
    }

    if (url.searchParams.has('language')) {
      url.searchParams.set('language', paramsLanguage);
    } else {
      url.searchParams.append('language', paramsLanguage);
    }

    return url.toString();
  } catch {
    return urlString;
  }
};

export const generateFlinksUrl = (
  externalIframeUrl: string,
  productShelfCurrencies: string[] | undefined,
  language?: LanguageCodes,
): string => {
  const currencies = productShelfCurrencies?.length
    ? productShelfCurrencies.map((c) => c.toLowerCase()).join(',')
    : CurrencyCodes.CAD.toLowerCase();

  return handleUrl(externalIframeUrl, currencies, language);
};
